import {environment} from '../environments/environment';

export const baseUrl = environment.baseUrl;
